'use client'

import { UrlProviderContextType } from '@/types/UrlProviderContext'
import { createContext, useContext, useState } from 'react'

const UrlContext = createContext<UrlProviderContextType | null>(null)

export const UrlProvider = ({ children }: { children: React.ReactNode }) => {
  const [url, setUrl] = useState<string>('')

  return <UrlContext.Provider value={{ url, setUrl }}>{children}</UrlContext.Provider>
}

export const useUrl = () => {
  const context = useContext(UrlContext)

  if (!context) {
    throw new Error('useUrl must be used within a UrlContext')
  }

  return context
}
